/** True if the DOM is available, false otherwise. */
export const CAN_USE_DOM =
  typeof window !== "undefined" &&
  typeof window.document !== "undefined" &&
  typeof window.document.createElement !== "undefined"

/** True if the system is Apple-based (e.g. MacOS or iOS), false otherwise. */
export const IS_APPLE = CAN_USE_DOM && /Mac|iPod|iPhone|iPad/.test(navigator.platform)
